<section class="help-screen tw-w-full" data-cy="help-screen">
  <!-- Heading bar: title separated from the content card
       (mirrors the Account Settings / Promotions header). -->
  <header
    class="
      heading-section
      tw-flex
      tw-h-[58.5px]
      tw-items-center
      tw-justify-between
      tw-bg-[#F0F0F0]
      tw-rounded-[12px]
      tw-p-[10px_18px]
      tw-mb-[16px]
    "
    data-cy="help-header"
  >
    <h3
      class="tw-font-bold tw-text-[18px] tw-text-[#000000] tw-tracking-[0.5px] tw-m-0"
      data-cy="help-title"
    >
      {{ 'account.help' | translate: 'Help' }}
    </h3>
    <button
      type="button"
      (click)="close()"
      class="
        help-close
        tw-flex
        tw-items-center
        tw-justify-center
        tw-bg-transparent
        tw-border-0
        tw-cursor-pointer
      "
      attr.aria-label="{{ 'ui.account.close.help' | translate: 'Close help' }}"
      data-cy="help-close"
    >
      <mat-icon class="!tw-text-[22px] tw-text-[#000000]">close</mat-icon>
    </button>
  </header>

  <!-- Content card -->
  <div class="help-panel tw-rounded-[12px] tw-p-[18px]" data-cy="help-panel">
    <p class="contact-label tw-font-bold tw-text-[16px] tw-mb-[16px]">{{ 'account.help.contactus' | translate: 'Contact Us:' }}</p>

    <!-- Support contact boxes -->
    <div class="contact-boxes tw-flex tw-flex-wrap tw-gap-[16px] tw-mb-[24px]">
      <a class="box-info" href="mailto:support@amwager.com">
        <img
          src="/assets/images/about_settings/help/email_support_icon.svg"
          alt="{{ 'ui.account.email.support.icon' | translate: 'email support icon' }}"
        >
        <span class="tw-font-bold tw-text-[#3080EC]">{{ 'ui.account.email.support' | translate: 'Email Support:' }}</span>
        <br>
        support&#64;amwager.com
      </a>

      <a class="box-info" href="tel:1-877-767-4447">
        <img
          src="/assets/images/about_settings/help/phone_support_icon.svg"
          alt="{{ 'ui.account.phone.support.icon' | translate: 'phone support icon' }}"
        >
        <span class="tw-font-bold tw-text-[#3080EC]">{{ 'ui.account.phone.support' | translate: 'Phone Support:' }}</span>
        <br>
        1-877-767-4447
      </a>

      <div class="box-info">
        <img
          src="/assets/images/about_settings/help/support_hours_icon.svg"
          alt="{{ 'ui.account.support.hours.icon' | translate: 'support hours icon' }}"
        >
        <span class="tw-font-bold tw-text-[#3080EC]">{{ 'ui.account.support.hours' | translate: 'Support Hours:' }}</span>
        <br>
        {{ 'ui.account.12pm.8pm.est' | translate: '12PM - 8PM EST' }}
      </div>
    </div>

    <!-- Quick links / actions -->
    <div class="help-actions tw-flex tw-flex-col tw-gap-[12px]">
      <a
        mat-flat-button
        color="primary"
        class="help-btn"
        [href]="userGuideUrl"
        target="_blank"
        rel="noreferrer"
        data-cy="help-user-guide"
      >
        {{ 'account.help.guide' | translate: 'User Guide' }}
      </a>

      <button
        mat-flat-button
        color="primary"
        type="button"
        class="help-btn"
        (click)="downloadRulesAndCodes()"
        data-cy="help-download-rules"
      >
        {{ 'account.help.fileupload.todayscodes' | translate: 'Download Rules & Codes for Today\'s Tracks' }}
      </button>

      <button
        mat-flat-button
        color="primary"
        type="button"
        class="help-btn"
        (click)="generateEncodedRunners()"
        data-cy="help-encoded-runners"
      >
        {{ 'account.help.download.encodedrunners' | translate: 'Generate & Copy Encoded Runners' }}
      </button>
    </div>
  </div>
</section>
